import Reveal from "./Reveal";

export default function SectionHeading({ number, title, dark = false }) {
    return (
        <Reveal>
            <div className="flex items-center gap-4">
                <span className="mono text-xs tracking-[0.3em]">{number}</span>
                <span
                    className={`h-px w-12 ${dark ? "bg-paper/40" : "bg-ink/40"}`}
                />
            </div>
            <h2
                data-testid={`section-heading-${title
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                className="font-display text-3xl md:text-5xl tracking-tight mt-3"
            >
                {title}
            </h2>
        </Reveal>
    );
}
